import React from 'react';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { useDailyOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/DailyOvertimeDashboard/store/dailyOvertimeDashboard.store';
import { HORIZONTAL_BAR_RIGHT_MARGIN } from 'pages/ReportsPage/components/AnalyticsDashboards/DailyOvertimeDashboard/DailyOvertimeDashboard.constants';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/DailyOvertimeDashboard/DailyOvertimeDashboard.styled';

export const OtByPositionChart: React.FC = () => {
  const data = useDailyOvertimeDashboardStore((s) => s.overtimeByPosition);
  const page = useDailyOvertimeDashboardStore((s) => s.byPositionPage);
  const totalPages = useDailyOvertimeDashboardStore((s) => s.byPositionTotalPages);
  const loadingMore = useDailyOvertimeDashboardStore((s) => s.byPositionLoadingMore);
  const loadMore = useDailyOvertimeDashboardStore((s) => s.loadMoreByPosition);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available for the selected filters.</EmptyStateContainer>;
  }

  const barColor = palette.chartColors[0];

  const maxOvertimeHours = Math.max(...data.map((d) => d.overtimeHours));

  const items: HorizontalBarItem[] = data.map((d) => ({
    label: d.position,
    value: d.overtimeHours,
    valueLabel: `${d.overtimeHours}h`,
    ariaLabel: `${d.position}: ${d.overtimeHours} overtime hours`,
    tooltipHtml: `<strong>${d.position}</strong><br/>Overtime: ${d.overtimeHours}h`,
    barColor,
  }));

  return (
    <HorizontalBarChart
      items={items}
      maxValue={maxOvertimeHours > 0 ? maxOvertimeHours : undefined}
      rightMargin={HORIZONTAL_BAR_RIGHT_MARGIN}
      leftMargin={170}
      wrapLabels
      ariaLabel="Overtime hours by position chart"
      scrollable
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
